import React from "react";
import { Box } from "@mui/material";
import Matrix6 from "../../img/logos/Matrix6.png";
import { normalizeOrgBrand } from "./skillAgentOrgBrand";

/** Icono STAGE (anillo Matrix6) o NML (monograma). */
export default function OrgBrandIcon({ brand, size = 28, sx }) {
  const b = normalizeOrgBrand(brand);
  if (b === "STAGE") {
    return (
      <Box
        component="img"
        src={Matrix6}
        alt="STAGE"
        sx={{
          width: size,
          height: size,
          objectFit: "contain",
          display: "block",
          borderRadius: "50%",
          ...sx,
        }}
      />
    );
  }
  return (
    <Box
      component="svg"
      viewBox="0 0 32 32"
      width={size}
      height={size}
      aria-label="NML"
      sx={{ display: "block", flexShrink: 0, ...sx }}
    >
      <rect x="1" y="1" width="30" height="30" rx="8" fill="#0d47a1" />
      <rect
        x="3.5"
        y="3.5"
        width="25"
        height="25"
        rx="6"
        fill="none"
        stroke="#90caf9"
        strokeWidth="1.25"
      />
      <text
        x="16"
        y="20.5"
        textAnchor="middle"
        fill="#ffffff"
        fontFamily="system-ui, Segoe UI, sans-serif"
        fontSize="9"
        fontWeight="800"
        letterSpacing="0.06em"
      >
        NML
      </text>
    </Box>
  );
}
